const INITIAL_STATE = {
    tasks: null,
      
  };
  
  const applyFetchTasks = (state, action) => ({
    ...state,
    tasks: action.tasks
  })

  function tasksReducer(state = INITIAL_STATE, action) {
    switch(action.type) {
      case 'FETCH_TASKS' : {
        return applyFetchTasks(state, action);
      }
      default : return state;
    }
  }
  
  export default tasksReducer;


// WEBPACK FOOTER //
// ./src/reducers/tasks.js